import { EntityServiceProvider, UtilityServiceProvider } from './datasource';
import { ENTITY_SERVICES } from './entityServices';
import { REPLENISH_DATA_SERVICES } from './replenish-worker/replenish-data';
import { UTILITY_SERVICES } from './utilityServices';

export * from './session/token-session.service';
export * from './base';
export * from './local-storage/local-storage.service';
export * from './expiring-storage/expiring-storage.service';
export * from './session';
export * from './xprt-data/xprt-data.service';
export * from './dm-data/dm-data.service';
export * from './tools';
export * from './login';
export * from './post-message';
export * from './state-service';
export * from './sidebar';
export * from './modal-loader';
export * from './datasource';
export * from './window-wrapper';
export * from './list-view';
export * from './orders';
export * from './country-format';
export * from './company';
export * from './number-format';
export * from './events';
export * from './sites';
export * from '@components/form/services/validation/validation.service';
export * from './transfer';
export * from './transfer-destinations';
export * from './qoh';
export * from './stand-worksheet';
export * from './inventory-count';
export * from './historical-quantities';
export * from './incomplete-transfer';
export * from './transfer-group';
export * from './task';
export * from './transfer-group-template';
export * from './scanning';
export * from './theme/theme.service';
export * from './translate';
export * from './hawker-profile';
export * from './boh-data';
export * from './xdm-commission-rate';
export * from './hawker-load';
export * from './hawker-commissary-assignment';
export * from './hawker-session';
export * from './hawker-commissary-assignment-history';

export const SERVICE_PROVIDERS: any[] = [
  ...ENTITY_SERVICES,
  ...UTILITY_SERVICES,
  ...REPLENISH_DATA_SERVICES,
  { provide: 'EntityServices', useValue: ENTITY_SERVICES },
  { provide: 'UtilityServices', useValue: UTILITY_SERVICES },
  EntityServiceProvider,
  UtilityServiceProvider,
];
